import { useState } from "react";
import { DateTime } from "luxon";
import Scrollbars from "react-custom-scrollbars";

// hooks and utilities
import { useLanguage } from "lang/Translate";
import usePrevious from "hooks/usePrevious";
import importAll from "common/importAll";

// assets
import changelogData from "assets/json/changelog.json";

// styles
import "./Changelog.scoped.scss";

const allThumbnails = importAll(require.context("assets/thumbnails", true, /\.jpeg$/));

function formatDate(date, lang) {
	const formattedDate = DateTime.fromISO(date)
		.setLocale(lang === "PL" ? "pl-pl" : "en-us")
		.toLocaleString();
	return formattedDate;
}

function Changelog() {
	const versions = Object.keys(changelogData);

	const [show, setShow] = useState(checkIfShow());
	const [selected, setSelected] = useState(versions[0]);
	const previousSelected = usePrevious(selected);
	const lang = useLanguage();

	function checkIfShow() {
		const version = require("../../../package.json").version;
		if (version === window.lastUsedVersion || window.lastUsedVersion == null) return false;

		const [currentMajor, currentMinor, currentPatch] = version.split("-")[0].split(".");
		const [lastMajor, lastMinor, lastPatch] = window.lastUsedVersion.split("-")[0].split(".");

		if (+currentMajor > +lastMajor) return true;
		if (currentMajor === lastMajor && +currentMinor > +lastMinor) return true;
		if (currentMajor === lastMajor && currentMinor === lastMinor && +currentPatch > +lastPatch) return true;
		return false;
	}

	if (!show) return null;
	return (
		<div className="changelog_container">
			<div className="changelog">
				<h2>{lang === "PL" ? "Historia wersji" : "Version history"}</h2>
				<h1>
					{(lang === "PL" ? "Zmiany w wersji" : "Changes in version") + " " + selected}
					<i>{formatDate(changelogData[selected].date, lang)}</i>
				</h1>
				<Scrollbars
					className="scroll_container"
					hideTracksWhenNotNeeded={true}
					renderTrackVertical={props => <div {...props} className="track_vertical" />}
					renderThumbVertical={props => <div {...props} className="thumb_vertical" />}
					renderTrackHorizontal={props => <div {...props} className="hide" />}
				>
					<ul className="version_list">
						{versions.map(version => (
							<li
								key={version}
								className={
									selected === version ? "selected" : previousSelected === version ? "previous" : undefined
								}
								onClick={() => setSelected(version)}
							>
								{version}
							</li>
						))}
						<p>
							{lang === "PL"
								? "Informacje o wcześniejszych wersjach są obecnie niedostępne"
								: "Information about previous versions is currently unavailable"}
						</p>
					</ul>
				</Scrollbars>
				<Scrollbars
					className="scroll_container"
					hideTracksWhenNotNeeded={true}
					renderTrackVertical={props => <div {...props} className="track_vertical" />}
					renderThumbVertical={props => <div {...props} className="thumb_vertical" />}
					renderTrackHorizontal={props => <div {...props} className="hide" />}
				>
					<div className="content">
						<img src={allThumbnails[changelogData[selected].image]} alt="" />

						<div className="details">
							{changelogData[selected].newFeatures && (
								<>
									<h3>{lang === "PL" ? "Nowe funkcje" : "New features"}</h3>
									<ul>
										{changelogData[selected].newFeatures[lang].map((str, i) => (
											<li key={i}>{str}</li>
										))}
									</ul>
								</>
							)}
							{changelogData[selected].improvements && (
								<>
									<h3>{lang === "PL" ? "Ulepszenia" : "Improvements"}</h3>
									<ul>
										{changelogData[selected].improvements[lang].map((str, i) => (
											<li key={i}>{str}</li>
										))}
									</ul>
								</>
							)}
							{changelogData[selected].bugfixes && (
								<>
									<h3>{lang === "PL" ? "Naprawione błędy" : "Bugfixes"}</h3>
									<ul>
										{changelogData[selected].bugfixes[lang].map((str, i) => (
											<li key={i}>{str}</li>
										))}
									</ul>
								</>
							)}
						</div>
					</div>
				</Scrollbars>
				<i className="fas fa-times close" onClick={() => setShow(false)} />
			</div>
		</div>
	);
}

export default Changelog;
